import { render } from "./GoTop.vue?vue&type=template&id=12ebbb9a&scoped=true&ts=true"
import script from "./GoTop.vue?vue&type=script&lang=ts"
export * from "./GoTop.vue?vue&type=script&lang=ts"

import "./GoTop.vue?vue&type=style&index=0&id=12ebbb9a&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ebbb9a"]])

export default __exports__